/*
 * @Author: Jing
 * @Date: 2021-11-04 09:30:29
 * @Descripttion:
 */
import { createRouter, createRouterMatcher, createWebHistory } from 'vue-router'
import { route } from './route'
import { checkLogin, setTitle, storageGet, storageSet, showWxShareMenu, hideWxShareMenu, inSkipAuth, storageRemove } from '@/utils/util'
import { getAppEnvConfig } from '@/utils/env'
import { getAllClinic } from '@/api'
import Cookies from 'js-cookie'

let { VITE_API_BASE_URL, NODE_ENV } = getAppEnvConfig()

let router = createRouter({
    history: createWebHistory(),
    routes: route,
})

router.beforeEach((to, from, next) => {
    console.log('路由 - to', to)
    setTitle(to.meta.title as string)
    // 微商城页面跳转
    if (to.path.indexOf('micro') > -1) {
        window.location.href = 'https://rlys.ruolinzs.com' + to.fullPath
    } else {
        // 判断是否有品牌ID
        let bid = to.query.brandId || to.params.brandId
        if (bid) {
            let localBid = storageGet('brandId')
            if (localBid && bid != localBid) {
                Cookies.remove('ljhyToken')
                Cookies.remove('brandId')
                window.localStorage.clear()
            }
            storageSet('brandId', bid as any)
            Cookies.set('brandId', bid as string)
        }

        if (!checkLogin()) {
            console.log('路由 - 没有登录')
            // 是否白名单
            if (to.path.indexOf('/examinationTriage') > -1 || to.path.indexOf('/noauth') > -1 || to.path.indexOf('/authorize') > -1) {
                console.log('路由 - 没有登录 - 白名单')
                next()
            } else {
                console.log('路由 - 没有登录 - 黑名单跳转授权登录')
                let url = '/authorize?brandId=' + bid + '&redir=' + encodeURIComponent(to.fullPath)
                next(url)
            }
        } else {
            // 扫码登录，不需要获取诊所列表
            if (to.path.indexOf('/qrcodeLogin') > -1 || to.path.indexOf('/noauth') > -1) {
                next()
            } else {
                let allClinic = storageGet('AllClinic')
                if (allClinic) {
                    console.log('路由 - 获取所有这所列表')
                    next()
                } else {
                    getAllClinic().then((res) => {
                        storageSet('AllClinic', res.data)
                        next()
                    })
                }
            }
        }
    }
})
router.afterEach((to, from) => {
    console.log('路由 - afterEach')
    // 判断显示隐藏分享按钮
    if (to.meta && to.meta.share) {
        console.log('路由 - 显示分享按钮')
        showWxShareMenu()
    } else {
        console.log('路由 - 隐藏分享按钮')
        hideWxShareMenu()
    }
})
export default router
